export default "__VITE_ASSET__CdDKOQeS__"